import { render, staticRenderFns } from "./sendMessageContent.vue?vue&type=template&id=449e3859&scoped=true"
import script from "./sendMessageContent.vue?vue&type=script&lang=js"
export * from "./sendMessageContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449e3859",
  null
  
)

export default component.exports